export const bookingCalendarTokens = Object.freeze({
    selected: '#9B004A',
    selectedShadow: 'rgba(155,0,74,.24)',
    occupiedBackground: '#fff7ed',
    occupiedHover: '#ffedd5',
    occupiedBorder: '#fb923c',
    occupiedText: '#c2410c',
    occupiedDot: '#f97316',
    radius: '10px',
});
